import { applyModules } from "./modules/utils"
import { Header } from "./modules/header"
import { Video } from "./modules/video"

applyModules('.header', Header)
applyModules('.video', Video)